import React, { useState, useRef, useEffect } from 'react';
import { Star, ShoppingBag, Heart, ChevronLeft, ChevronRight, Crown, Award, CheckCircle, Eye, Plus, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';

// Importăm pozele pentru primul produs
import p1 from '../assets/prod1/p1.jpg';
import p2 from '../assets/prod1/p2.jpg';
import p3 from '../assets/prod1/p3.jpg';
import p4 from '../assets/prod1/p4.jpg';
import p5 from '../assets/prod1/p5.jpg';
import p6 from '../assets/prod1/p6.jpg';
import p7 from '../assets/prod1/p7.jpg';

// Importăm pozele pentru al doilea produs
import prod2_p1 from '../assets/prod2/p1.jpg';
import prod2_p2 from '../assets/prod2/p2.jpg';
import prod2_p3 from '../assets/prod2/p3.jpg';

// Importăm pozele pentru al treilea produs
import prod3_p1 from '../assets/prod3/p1.jpg';
import prod3_p2 from '../assets/prod3/p2.jpg';

// Importăm pozele pentru al patrulea produs
import prod4_p1 from '../assets/prod4/p1.jpg';
import prod4_p2 from '../assets/prod4/p2.jpg';
import prod4_p3 from '../assets/prod4/p3.jpg';

// Importăm pozele pentru al cincilea produs
import prod5_p1 from '../assets/prod5/p1.jpg';
import prod5_p2 from '../assets/prod5/p2.jpg';
import prod5_p3 from '../assets/prod5/p3.jpg';
import prod5_p4 from '../assets/prod5/p4.jpg';
import prod5_p5 from '../assets/prod5/p5.jpg';
import prod5_p6 from '../assets/prod5/p6.jpg';
import prod5_p7 from '../assets/prod5/p7.jpg';

// Importăm pozele pentru al șaselea produs
import prod6_p1 from '../assets/prod6/p1.jpg';
import prod6_p2 from '../assets/prod6/p2.jpg';
import prod6_p3 from '../assets/prod6/p3.jpg';
import prod6_p4 from '../assets/prod6/p4.jpg';

// Importăm pozele pentru al șaptelea produs
import prod7_p1 from '../assets/prod7/p1.jpg';
import prod7_p2 from '../assets/prod7/p2.jpg';
import prod7_p3 from '../assets/prod7/p3.jpg';
import prod7_p4 from '../assets/prod7/p4.jpg';

// Importăm pozele pentru al optulea produs
import prod8_p1 from '../assets/prod8/p1.jpg';
import prod8_p2 from '../assets/prod8/p2.jpg';
import prod8_p3 from '../assets/prod8/p3.jpg';
import prod8_p4 from '../assets/prod8/p4.jpg';
import prod8_p5 from '../assets/prod8/p5.jpg';
import prod8_p6 from '../assets/prod8/p6.jpg';

// Importăm pozele pentru al nouălea produs
import prod9_p1 from '../assets/prod9/p1.jpg';
import prod9_p2 from '../assets/prod9/p2.jpg';
import prod9_p3 from '../assets/prod9/p3.jpg';

const ProductsSection = () => {
  const [inView, setInView] = useState(false);
  const [activeProduct, setActiveProduct] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [favorites, setFavorites] = useState(new Set());
  const [addedToCart, setAddedToCart] = useState(new Set());
  const sectionRef = useRef(null);
  
  // Cart functionality
  const { addToCart, getItemQuantity } = useCart();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Datele produselor
  const products = [
    {
      id: 1,
      title: "Trusou de botez fetiță crem cu dantelă și perle – Model Anastasia",
      price: "960.00",
      rating: 5.00,
      reviews: 2,
      images: [p1, p2, p3, p4, p5, p6, p7],
      content: [
        "Cutie lucrată manual, personalizată cu nume și dată",
        "Prosop preot (30 x 50 cm)",
        "Săpun handmade personalizat",
        "Muselină bebe cu capișon, brodată cu numele",
        "Pânză de mir din muselină, personalizată prin broderie",
        "Fașă personalizată cu numele bebelușului"
      ],
      details: "Trusoul de botez pentru fetiță Anastasia, în nuanțe crem cu dantelă și perle, este realizat manual și personalizat integral. Set complet de 6 piese elegante, potrivit pentru o ceremonie de poveste.",
      note: "Ținuta și lumânarea se achiziționează separat. Conținutul trusoului nu se vinde individual.",
      dimensions: "26 x 15 cm",
      category: "Trusouri Premium",
      featured: true
    },
    {
      id: 2,
      title: "Lumânare de Botez din ceară naturală mov cu flori delicate – Model Maria",
      price: "380.00",
      rating: 4.8,
      reviews: 5,
      images: [prod2_p1, prod2_p2, prod2_p3],
      content: [
        "Ceară naturală 100% premium",
        "Flori delicate în nuanțe mov",
        "Personalizare cu numele copilului",
        "Design elegant și rafinat",
        "Lucru manual artizanal",
        "Ambalare cadou inclusă"
      ],
      details: "Lumânarea de botez Model Maria este confecționată din ceară naturală de înaltă calitate, decorată cu flori delicate în nuanțe mov. Fiecare piesă este realizată manual cu atenție la detalii.",
      note: "Poate fi personalizată cu numele și data botezului. Timpul de realizare: 3-5 zile lucrătoare.",
      dimensions: "Înălțime: 25 cm",
      category: "Lumânări Personalizate",
      featured: false
    },
    {
      id: 3,
      title: "Rochiță elegantă cu brocard floral și tulle roz – Model Elise",
      price: "380.00",
      rating: 4.9,
      reviews: 8,
      images: [prod3_p1, prod3_p2],
      content: [
        "Brocard floral de înaltă calitate",
        "Tulle fin în nuanțe roz delicate",
        "Croială elegantă pentru fetiță",
        "Finisaje rafinate handmade",
        "Design exclusiv Model Elise",
        "Mărimi disponibile: 3-24 luni"
      ],
      details: "Rochița Model Elise este o creație elegantă, confecționată din brocard floral premium și tulle fin roz. Designul rafinat și atenția la detalii fac din această rochițe alegerea perfectă pentru botez.",
      note: "Se asortează perfect cu trusourile noastre de botez. Disponibilă în mai multe mărimi pentru confortul bebelușului.",
      dimensions: "Mărimi: 3-24 luni",
      category: "Rochițe de Botez",
      featured: false
    },
    {
      id: 4,
      title: "Salopetă fetiță și băiețel, elegantă cu detalii brodate – Model Sol",
      price: "369.00",
      rating: 4.7,
      reviews: 12,
      images: [prod4_p1, prod4_p2, prod4_p3],
      content: [
        "Design unisex pentru fetițe și băieței",
        "Detalii brodate fine și elegante",
        "Material moale și confortabil",
        "Croială practică pentru schimbat",
        "Finisaje de calitate premium",
        "Mărimi disponibile: 0-24 luni"
      ],
      details: "Salopeta Model Sol este o opțiune elegantă și practică, potrivită atât pentru fetițe, cât și pentru băieței. Detaliile brodate fine și materialul de calitate fac din această salopetă alegerea perfectă pentru momentele speciale.",
      note: "Design unisex care se potrivește perfect pentru orice ceremonie de botez. Confort maxim pentru bebeluș.",
      dimensions: "Mărimi: 0-24 luni",
      category: "Costume & Salopete",
      featured: false
    },
    {
      id: 5,
      title: "Trusou Botez-Eduard Conte",
      price: "960.00",
      rating: 5.00,
      reviews: 7,
      images: [prod5_p1, prod5_p2, prod5_p3, prod5_p4, prod5_p5, prod5_p6, prod5_p7],
      content: [
        "Cutie lucrată manual personalizată cu numele bebelușului și data evenimentului",
        "Prosop preot",
        "Săpun handmade personalizat",
        "Prosop bebe cu dantelă personalizat cu numele prin broderie",
        "Pânză de mir personalizată cu numele prin broderie",
        "Fașă personalizată cu numele prin broderie"
      ],
      details: "Trusou Botez-Eduard Conte PREMIUM include un set complet de 6 piese elegante, fiecare personalizată cu numele bebelușului și data evenimentului. Toate elementele sunt realizate manual cu măiestrie și atenție la detalii.",
      note: "Ținuta și lumânarea se achiziționează separat, fotografiile în care apar aceste produse, fiind doar cu titlu de prezentare. Elementele ce fac parte din conținutul trusoului, nu se pot achiziționa separat.",
      dimensions: "26 x 15 cm",
      category: "Trusouri Premium",
      featured: true
    },
    {
      id: 6,
      title: "Lumânare Botez Eduard Royal",
      price: "336.00",
      rating: 5.00,
      reviews: 2,
      images: [prod6_p1, prod6_p2, prod6_p3, prod6_p4],
      content: [
        "Lumânare mică din parafină de calitate",
        "Decorată cu elemente aurii elegante",
        "Dantelă fină aplicată manual",
        "Lucrată în atelierul Botez de Poveste",
        "Inscripționată cu numele bebelușului",
        "Personalizare inclusă în preț"
      ],
      details: "Lumânare mică din parafină, decorată cu elemente aurii și dantelă, lucrată în atelierul Botez de Poveste. Lumânarea se inscripționează cu numele bebelușului și data botezului. Personalizarea lumânării de botez băieței, este inclusă în preț.",
      note: "Fotografiile sunt cu titlu de prezentare, produsul poate suferi mici diferențe, fiind un model realizat manual. Suportul este doar pentru poza de prezentare și nu face parte din produs.",
      dimensions: "34 cm înălțime x 7 cm grosime",
      category: "Lumânări Personalizate",
      featured: false
    },
    {
      id: 7,
      title: "Lumânare Botez Ursulet Floral – Ceară Naturală",
      price: "380.00",
      rating: 4.9,
      reviews: 6,
      images: [prod7_p1, prod7_p2, prod7_p3, prod7_p4],
      content: [
        "Ceară naturală de tip fagure",
        "Ursulet de plus accesoriu",
        "Trandafir criogenat bleu",
        "Trandafir din lemn handmade",
        "Lagurus și spice de grâu",
        "Ferigă și accesorii textile"
      ],
      details: "Această lumânare pentru botez este confecționată din ceară naturală, de tip fagure, și accesorizată cu ursulet de plus și flori uscate, stabilizate, precum și flori artificiale de o elegantă debordantă și un realism suprem. Aranjamentul floral DADA include: trandafir criogenat bleu, trandafir din lemn, lagurus, spice de grâu, ferigă, accesorii textile și benzi.",
      note: "Produsul poate avea mici variații în aranjamentul floral, fiind realizat manual cu flori naturale și stabilizate.",
      dimensions: "Înălțime: 35 cm, Diametru: 5.5 cm",
      category: "Lumânări Personalizate",
      featured: false
    },
    {
      id: 8,
      title: "Lumânare Botez Ursulet Floral – Ceară Naturală – Model Compact",
      price: "229.00",
      rating: 4.8,
      reviews: 4,
      images: [prod8_p1, prod8_p2, prod8_p3, prod8_p4, prod8_p5, prod8_p6],
      content: [
        "Ceară naturală de calitate premium",
        "Design compact și elegant",
        "Ursulet de plus accesoriu",
        "Aranjament floral delicat",
        "Flori stabilizate și artificiale",
        "Lucru manual artizanal"
      ],
      details: "Variantă compactă a lumânării Ursulet Floral, confecționată din ceară naturală și accesorizată cu ursulet de plus și un aranjament floral delicat. Perfectă pentru ceremoniile de botez care preferă un design mai discret dar la fel de elegant.",
      note: "Model compact cu preț accesibil, fără a compromite calitatea și eleganța. Poate avea mici variații în aranjament, fiind lucrat manual.",
      dimensions: "Dimensiuni compacte, potrivite pentru orice spațiu",
      category: "Lumânări Personalizate",
      featured: false
    },
    {
      id: 9,
      title: "Lumânare Botez Ursulet Floral – Ceară Naturală – Model Standard",
      price: "339.00",
      rating: 4.7,
      reviews: 5,
      images: [prod9_p1, prod9_p2, prod9_p3],
      content: [
        "Ceară naturală de calitate premium",
        "Design standard elegant",
        "Ursulet de plus inclus",
        "Aranjament floral echilibrat",
        "Flori naturale și stabilizate",
        "Finisaje atente la detalii"
      ],
      details: "Variantă standard a lumânării Ursulet Floral, confecționată din ceară naturală cu ursulet de plus și aranjament floral echilibrat. Oferă raportul perfect între calitate, design și preț accesibil pentru orice ceremonie de botez.",
      note: "Model standard cu preț echilibrat, perfect pentru ceremoniile clasice de botez. Poate avea mici variații în aranjament, fiind realizat manual.",
      dimensions: "Dimensiuni standard, potrivite pentru majoritatea ceremoniilor",
      category: "Lumânări Personalizate",
      featured: false
    }
  ];

  // Inițializare index imagini
  useEffect(() => {
    const initialIndexes = {};
    products.forEach(product => {
      initialIndexes[product.id] = 0;
    });
    setCurrentImageIndex(initialIndexes);
  }, []);

  const toggleFavorite = (productId) => {
    const newFavorites = new Set(favorites);
    if (newFavorites.has(productId)) {
      newFavorites.delete(productId);
    } else {
      newFavorites.add(productId);
    }
    setFavorites(newFavorites);
  };

  const handleAddToCart = (product) => {
    addToCart({
      id: product.id,
      title: product.title,
      price: product.price,
      images: product.images,
      category: product.category
    });
    
    // Afișează feedback vizual că produsul a fost adăugat
    setAddedToCart(prev => new Set([...prev, product.id]));
    
    // Elimină feedback-ul după 2 secunde
    setTimeout(() => {
      setAddedToCart(prev => {
        const newSet = new Set(prev);
        newSet.delete(product.id);
        return newSet;
      });
    }, 2000);
  };

  const nextImage = (productId) => {
    const product = products.find(p => p.id === productId);
    setCurrentImageIndex(prev => ({
      ...prev,
      [productId]: (prev[productId] + 1) % product.images.length
    }));
  };

  const prevImage = (productId) => {
    const product = products.find(p => p.id === productId);
    setCurrentImageIndex(prev => ({
      ...prev,
      [productId]: prev[productId] === 0 ? product.images.length - 1 : prev[productId] - 1
    }));
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star 
        key={i} 
        className={`w-3 h-3 sm:w-4 sm:h-4 ${i < rating ? 'text-gold-500 fill-current' : 'text-gray-300'}`} 
      />
    ));
  };

  const ProductCard = ({ product, index }) => (
    <div 
      className={`relative group transition-all duration-700 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      style={{ transitionDelay: `${index * 0.2}s` }}
    >
      <div className="bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 h-full flex flex-col">
        
        {/* Badge pentru produs recomandat */}
        {product.featured && (
          <div className="absolute top-2 left-2 sm:top-4 sm:left-4 z-10">
            <div className="bg-gradient-to-r from-gold-500 to-gold-600 text-white px-2 py-1 sm:px-3 sm:py-1 rounded-full text-xs font-semibold flex items-center shadow-lg">
              <Crown className="w-3 h-3 mr-1" />
              <span className="hidden xs:inline">PREMIUM</span>
              <span className="xs:hidden">★</span>
            </div>
          </div>
        )}

        {/* Buton favorite */}
        <button
          onClick={() => toggleFavorite(product.id)}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all duration-300"
        >
          <Heart 
            className={`w-4 h-4 sm:w-5 sm:h-5 transition-colors duration-300 ${
              favorites.has(product.id) ? 'text-red-500 fill-current' : 'text-gray-600'
            }`} 
          />
        </button>

        {/* Galeria de imagini - RESPONSIVE */}
        <div className="relative h-48 xs:h-56 sm:h-64 md:h-72 lg:h-80 overflow-hidden">
          <img 
            src={product.images[currentImageIndex[product.id] || 0]}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          
          {/* Overlay gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          
          {/* Navigare imagini */}
          {product.images.length > 1 && (
            <>
              <button
                onClick={() => prevImage(product.id)}
                className="absolute left-1 sm:left-2 top-1/2 -translate-y-1/2 w-6 h-6 sm:w-8 sm:h-8 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-white"
              >
                <ChevronLeft className="w-3 h-3 sm:w-4 sm:h-4 text-gray-700" />
              </button>
              <button
                onClick={() => nextImage(product.id)}
                className="absolute right-1 sm:right-2 top-1/2 -translate-y-1/2 w-6 h-6 sm:w-8 sm:h-8 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-white"
              >
                <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 text-gray-700" />
              </button>

              {/* Indicatori imagini */}
              <div className="absolute bottom-2 sm:bottom-3 left-1/2 -translate-x-1/2 flex space-x-1">
                {product.images.map((_, imageIndex) => (
                  <button
                    key={imageIndex}
                    onClick={() => setCurrentImageIndex(prev => ({ ...prev, [product.id]: imageIndex }))}
                    className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all duration-300 ${
                      imageIndex === (currentImageIndex[product.id] || 0) 
                        ? 'bg-white shadow-lg' 
                        : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        {/* Conținutul cardului - RESPONSIVE */}
        <div className="p-3 sm:p-4 lg:p-6 flex-1 flex flex-col">
          {/* Categoria */}
          <div className="flex items-center justify-between mb-2 sm:mb-3">
            <span className="text-xs font-semibold text-navy-600 bg-navy-100 px-2 py-1 rounded-full">
              {product.category}
            </span>
          </div>

          {/* Titlul - RESPONSIVE */}
          <h3 className="font-bold text-base sm:text-lg lg:text-xl text-gray-900 mb-2 sm:mb-3 line-clamp-2 group-hover:text-navy-600 transition-colors duration-300 leading-tight">
            {product.title}
          </h3>

          {/* Rating și recenzii - RESPONSIVE */}
          <div className="flex items-center mb-3 sm:mb-4">
            <div className="flex items-center mr-2">
              {renderStars(product.rating)}
            </div>
            <span className="text-xs sm:text-sm text-gray-600">
              {product.rating.toFixed(2)} ({product.reviews} recenzii)
            </span>
          </div>

          {/* Conținutul trusoului - RESPONSIVE */}
          <div className="mb-3 sm:mb-4 flex-1">
            <h4 className="text-xs sm:text-sm font-semibold text-gray-700 mb-2 flex items-center">
              <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 mr-1 text-emerald-500 flex-shrink-0" />
              Conținut trusou:
            </h4>
            <ul className="space-y-1">
              {/* Pe mobile afișăm doar 2 elemente, pe desktop 3 */}
              {product.content.slice(0, window.innerWidth < 640 ? 2 : 3).map((item, index) => (
                <li key={index} className="text-xs sm:text-sm text-gray-600 flex items-start leading-tight">
                  <span className="w-1 h-1 bg-gold-500 rounded-full mt-1.5 sm:mt-2 mr-2 flex-shrink-0"></span>
                  <span className="flex-1">{item}</span>
                </li>
              ))}
              {product.content.length > (window.innerWidth < 640 ? 2 : 3) && (
                <li className="text-xs sm:text-sm text-navy-600 font-medium">
                  +{product.content.length - (window.innerWidth < 640 ? 2 : 3)} componente suplimentare
                </li>
              )}
            </ul>
          </div>

          {/* Preț și acțiuni - RESPONSIVE */}
          <div className="flex items-center justify-between pt-3 sm:pt-4 border-t border-gray-100 mt-auto">
            <div className="flex-1">
              <span className="text-xl sm:text-2xl font-bold text-gray-900">{product.price}</span>
              <span className="text-sm text-gray-600 ml-1">lei</span>
              {getItemQuantity(product.id) > 0 && (
                <div className="text-xs text-emerald-600 font-medium mt-1">
                  {getItemQuantity(product.id)} în coș
                </div>
              )}
            </div>
            
            <div className="flex space-x-2">
              <button 
                onClick={() => handleAddToCart(product)}
                className={`px-3 py-2 sm:px-4 sm:py-2 rounded-lg sm:rounded-xl font-semibold text-xs sm:text-sm transition-all duration-300 flex items-center shadow-lg hover:shadow-xl flex-shrink-0 ${
                  addedToCart.has(product.id)
                    ? 'bg-emerald-600 hover:bg-emerald-700 text-white'
                    : 'bg-gradient-to-r from-navy-600 to-navy-700 hover:from-navy-700 hover:to-navy-800 text-white'
                }`}
              >
                {addedToCart.has(product.id) ? (
                  <>
                    <Check className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden xs:inline">Adăugat!</span>
                    <span className="xs:hidden">✓</span>
                  </>
                ) : (
                  <>
                    <Plus className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="hidden xs:inline">Adaugă în coș</span>
                    <span className="xs:hidden">+</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section id="produse" ref={sectionRef} className="py-10 sm:py-16 lg:py-20 bg-gradient-to-b from-cream-50 to-white relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 -left-32 w-64 h-64 sm:w-96 sm:h-96 rounded-full bg-gradient-to-r from-gold-100/30 to-navy-100/30 blur-3xl"></div>
        <div className="absolute bottom-10 -right-32 w-64 h-64 sm:w-96 sm:h-96 rounded-full bg-gradient-to-r from-emerald-100/30 to-gold-100/30 blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header - RESPONSIVE */}
        <div className={`text-center mb-8 sm:mb-12 lg:mb-16 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-flex items-center px-4 py-2 sm:px-6 sm:py-3 rounded-full glass border border-navy-200/50 text-navy-600 font-medium text-xs sm:text-sm mb-4 sm:mb-6">
            <Crown className="w-3 h-3 sm:w-4 sm:h-4 mr-2 text-gold-600 animate-pulse" />
            Colecția Noastră Premium
          </div>
          
          <h2 className="text-3xl xs:text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 font-display px-4">
            <span className="gradient-text">Produse</span> de Poveste
          </h2>
          
          <p className="text-lg xs:text-xl sm:text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Descoperiți colecția noastră exclusivă de trusouri personalizate, 
            create manual cu dragoste pentru momentele speciale ale copiilor dumneavoastră.
          </p>
        </div>

        {/* Products Grid - COMPLET RESPONSIVE */}
        <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-7xl mx-auto">
          {products.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>

        {/* Call to Action - RESPONSIVE */}
        <div className={`text-center mt-8 sm:mt-12 lg:mt-16 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '0.6s' }}>
          <div className="relative max-w-4xl mx-auto px-4">
            <div className="absolute inset-0 bg-gradient-to-r from-navy-500/10 via-gold-500/10 to-emerald-500/10 rounded-2xl sm:rounded-3xl blur-xl"></div>
            <div className="relative glass-cream rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 border border-gold-200/30 shadow-lg">
              <div className="flex justify-center mb-3 sm:mb-4">
                <div className="flex -space-x-1 sm:-space-x-2">
                  {[Crown, Award, Eye].map((Icon, index) => (
                    <div 
                      key={index} 
                      className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shadow-lg border-2 sm:border-3 border-white ${
                        index === 0 ? 'bg-gradient-to-br from-navy-600 to-navy-700' :
                        index === 1 ? 'bg-gradient-to-br from-gold-600 to-gold-700' :
                        'bg-gradient-to-br from-emerald-600 to-emerald-700'
                      }`}
                    >
                      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                    </div>
                  ))}
                </div>
              </div>
              
              <h4 className="text-xl xs:text-2xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2 sm:mb-3 font-display px-2">
                Vreți să vedeți <span className="gradient-text">întreaga colecție</span>?
              </h4>
              
              <p className="text-sm xs:text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 max-w-2xl mx-auto px-2">
                Contactați-ne pentru a descoperi toate modelele disponibile și pentru 
                personalizări complete după preferințele dumneavoastră.
              </p>
              
              <button 
                onClick={() => {
                  // Scroll la secțiunea de produse pentru a vedea toate produsele
                  const element = document.getElementById('produse');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="morph-button px-6 py-3 sm:px-8 sm:py-4 bg-gradient-to-r from-navy-600 to-navy-700 text-white rounded-full hover:from-navy-700 hover:to-navy-800 font-semibold shadow-navy hover:shadow-2xl transition-all duration-300"
              >
                <span className="flex items-center justify-center text-sm sm:text-base">
                  <Eye className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
                  <span className="hidden xs:inline">Vezi Toate Produsele</span>
                  <span className="xs:hidden">Vezi Tot</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-4 sm:left-16 w-2 h-2 sm:w-3 sm:h-3 bg-gold-400 rounded-full opacity-40 animate-pulse"></div>
      <div className="absolute top-32 sm:top-48 right-4 sm:right-20 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-navy-400 rounded-full opacity-30 animate-bounce"></div>
      <div className="absolute bottom-16 sm:bottom-32 left-2 sm:left-12 w-3 h-3 sm:w-4 sm:h-4 bg-emerald-400 rounded-full opacity-50 animate-ping"></div>
    </section>
  );
};

export default ProductsSection;